import utils from 'utils'

class addRedFrom {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, $location, $state, $stateParams, $uibModal) {
        $scope.selectItem = {}
        $scope.confirmSheetState = $stateParams.currentTab?$stateParams.currentTab:'selectTicketTab'

        // 当前进度
        $scope.getProgressStatus = (currentTab) => {
            let status = 'notStarted'
            const stateControl = {
                selectTicketTab: {
                    mapper() {
                        status = 'notStarted'
                        if (currentTab === 'selectTicketTab') {
                            status = 'active'
                        }
                    },
                },
                inforConfirmTab: {
                    mapper() {
                        status = 'notStarted'
                        if (currentTab === 'selectTicketTab') {
                            status = 'completed'
                        } else if (currentTab === 'inforConfirmTab') {
                            status = 'active'
                        }
                    },
                },
                submitSuccessTab: {
                    mapper() {
                        status = 'completed'
                        if (currentTab === 'submitSuccessTab') {
                            status = 'active'
                        }
                    },
                },
            }
            stateControl[$scope.confirmSheetState].mapper()
            return status
        }
        /**
         * @description: 改变状态
         * @param {*} currentTab
         */
        $scope.changeState = (currentTab, item) => {
            $scope.selectItem = item
            $scope.confirmSheetState = currentTab
        }
    }
}

addRedFrom.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', '$location', '$state', '$stateParams', '$uibModal']
export default addRedFrom



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/addRedFrom.js